import React from "react";
import HelpAndSupportHeader from "../CommonComponents/HelpAndSupportHeader";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import ErrorMessage from "../CommonComponents/ErrorMessage";

import api from "../../api/api";

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

class UserDetailsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            headerMessage: {
                title: "User's Profile",
                description: "Update all details",
                backIcon: false,
                moreOptionhidden: true,
                searchOptionHidden: true
            },
            fName: "",
            lName: "",
            email: "",
            submitBtnDisable: true
        };
    }

    goBack = () => {
        this.props.history.goBack();
    };

    errorCloseCLick = () => {
        this.setState({
            displayErrorPopup: false
        });
    };

    makeSubmitBtnEnable = () => {
        const {fName, lName, email} = this.state;
        let enable = false;
        if (fName >= 1) enable = true;
        if (lName >= 1) enable = true;
        if (validateEmail(email)) enable = true;
        this.setState({submitBtnDisable: !enable});
    };

    submitData = () => {
        const {fName, lName, email} = this.state;
        const {countryCode, userId, userIdv2} = this.props;

        if (userIdv2) {
            const obj2 = {
                fName,
                lName,
                email,
                userId: userIdv2
            };

            api
                .updateUserDatav2(obj2)
                .then(data => {
                    const {id, fName, lName, email, city,countryCode, mobile} = data;
                    this.props.dispatch({
                        type: "SET_NAME",
                        payload: {name: `${fName} ${lName}`, fName, lName}
                    });
                    this.props.dispatch({
                        type: "SET_MOBILE",
                        payload: {mobile, countryCode: countryCode}
                    });
                    this.props.dispatch({type: "SET_EMAIL", payload: email});
                    console.log({city})
                this.props.dispatch({type: "SET_CITY", payload: city});
                })
                .catch(error => {
                    this.setState({
                        displayErrorPopup: true
                    });
                    api.displayHideLoader();
                });
        } else {
            const obj = {
                fName,
                lName,
                emailId: email,
                countryCode,
                userId
            };

            api
                .updateUserData(obj)
                .then(data => {
                    const {_id, fName, lName, emailId, phoneCountryCode, mobile} = data;
                    this.props.dispatch({
                        type: "SET_NAME",
                        payload: {name: `${fName} ${lName}`, fName, lName}
                    });
                    this.props.dispatch({
                        type: "SET_MOBILE",
                        payload: {mobile, countryCode: phoneCountryCode}
                    });
                    this.props.dispatch({type: "SET_EMAIL", payload: emailId});
                })
                .catch(error => {
                    this.setState({
                        displayErrorPopup: true
                    });
                    api.displayHideLoader();
                });
        }
    };

    onChange = field => e => {
        const value = e.target.value;
        const obj = {};
        obj[field] = value;
        this.setState(obj, this.makeSubmitBtnEnable);
    };

    componentDidMount() {
        const {fName, lName, email} = this.props;
        this.setState({fName, lName, email});
    }

    render() {
        const {fName, lName, email} = this.state;
        return (
            <div className="user-profile">
                {this.state.displayErrorPopup ? <ErrorMessage onCloseClick={this.errorCloseCLick.bind(this)}/> : null}

                <HelpAndSupportHeader displayMessage={this.state.headerMessage} back={this.goBack.bind(this)}/>
                <div className="body-container">
                    <div className="ticket-box-container">
                        <div className="ticket-box">
                            <div className="ticket-box-title">First Name</div>
                            <input
                                type="text"
                                className="ticket-box-input"
                                placeholder="Enter Your First Name"
                                maxLength="64"
                                value={fName}
                                onChange={this.onChange("fName")}
                                style={{paddingLeft: 0}}
                            />
                        </div>
                    </div>

                    <div className="ticket-box-container">
                        <div className="ticket-box">
                            <div className="ticket-box-title">Last Name</div>
                            <input
                                type="text"
                                className="ticket-box-input"
                                placeholder="Enter Your Last Name"
                                maxLength="64"
                                value={lName}
                                onChange={this.onChange("lName")}
                                style={{paddingLeft: 0}}
                            />
                        </div>
                    </div>

                    <div className="ticket-box-container">
                        <div className="ticket-box">
                            <div className="ticket-box-title">Email Id</div>
                            <input
                                type="email"
                                className="ticket-box-input"
                                placeholder="Enter Your Email Id"
                                maxLength="100"
                                value={email}
                                onChange={this.onChange("email")}
                                style={{paddingLeft: 0}}
                            />
                        </div>
                    </div>
                    <div className="submit-btn-container">
                        <input
                            type="button"
                            className="submit-btn"
                            onClick={this.submitData}
                            disabled={this.state.submitBtnDisable}
                            value="Update"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({userId, email, name, mobile, fName, lName, countryCode, userIdv2}) => ({
    userId,
    email,
    name,
    mobile,
    fName,
    lName,
    countryCode,
    userIdv2
});

export default connect(mapStateToProps)(withRouter(UserDetailsForm));



// WEBPACK FOOTER //
// ./src/components/UserDetails/UserDetails.js